import { useEffect, useState } from "react";
import { anchorLinks } from "@/mocks/site";

export default function AnchorNav() {
  const [active, setActive] = useState(anchorLinks[0].hash);

  useEffect(() => {
    const onScroll = () => {
      const offset = 180;
      let current = anchorLinks[0].hash;
      anchorLinks.forEach((anchor) => {
        const el = document.getElementById(anchor.hash);
        if (el && el.getBoundingClientRect().top <= offset) {
          current = anchor.hash;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="sticky top-[104px] z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <nav aria-label="首页板块导航" className="mx-auto max-w-[1440px] px-4 md:px-6">
        <ul className="hide-scrollbar flex items-center gap-1 overflow-x-auto py-2">
          {anchorLinks.map((anchor) => {
            const isActive = active === anchor.hash;
            return (
              <li key={anchor.hash} className="shrink-0">
                <a
                  href={`#${anchor.hash}`}
                  className={[
                    "flex items-center gap-2 whitespace-nowrap rounded-full px-3.5 py-2 text-xs transition-colors",
                    isActive
                      ? "bg-primary-800 font-medium text-background-50"
                      : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900",
                  ].join(" ")}
                >
                  {anchor.label}
                  <span className="hidden text-[10px] opacity-70 lg:inline">{anchor.desc}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}